export default {
  ZILLOW_BRAND: 'zillow',
};
